// extracted by mini-css-extract-plugin
module.exports = {"instructions":"invoiceDealInstructions_instructions__IxP0P","link":"invoiceDealInstructions_link__37cRZ","text":"invoiceDealInstructions_text__AsW59"};